module.exports = __webpack_public_path__ + "static/media/post-dia-de-la-madre.07f0ec66.jpg";